import ViewConstructor from './../components/ViewConstructor';

class GalleryManage extends ViewConstructor {
  componentDidEnter() {
    var user = Cookie.getJSON('gallery-user');
    var $ref = $(`#${ this.state.generatedId }`);

    if (user && user.email) {
      // update user details
      this.updateUserDetails(user);
    } else if (user) {
      // redirect to login
      // user found but no email ... means there's a temp user
      $ref.find('#redirect-create').trigger('click');
    } else {
      // no user found. Redirect to login page
      $ref.find('#redirect-login').trigger('click');
    }

    $ref.find('.gallery-form-update-email').off().on('submit', this.handleUpdateEmail.bind(this));
    $ref.find('.gallery-form-update-password').off().on('submit', this.handleUpdatePassword.bind(this));

    $ref.find('.gallery-form-update-password input').off().on('focus', function() {
      if ($ref.find('.gallery-form-update-password').hasClass('view')) {
        // toggleCurrentView();
        $ref.find('.gallery-form-update-password div.change a').trigger('click');
      }
    });

    $ref.find('.gallery-form-update-email input').off().on('focus', function() {
      if ($ref.find('.gallery-form-update-email').hasClass('view')) {
        $ref.find('.gallery-form-update-email div.change a').trigger('click');
      }
    });

    $ref.find('.gallery-form div a').off().on('click', toggleCurrentView);

    function toggleCurrentView() {
      $(this).parents('.gallery-form').toggleClass('edit');
      $(this).parents('.gallery-form').toggleClass('view');

      if ($(this).parents('.gallery-form').hasClass('edit')) {
        if ($(this).parents('.gallery-form').hasClass('gallery-form-update-password')) {
          $(this).parents('.gallery-form').find('input[name="gallery_password"]').val('').focus();
        } else {
          $(this).parents('.gallery-form').find('input').focus();
        }
      } else {
        $ref.find('.errors').slideUp();
        $(this).parents('.gallery-form').find('input').blur();
        if ($(this).parents('.gallery-form').hasClass('gallery-form-update-password')) {
          $(this).parents('.gallery-form').find('input[name="gallery_password"]').val('NOTUPINHERE');
        } else {
          $(this).parents('.gallery-form').find('input').val(user.email);
        }
      }
    }
  }
  updateUserDetails(userObj) {
    var $ref = $(`#${ this.state.generatedId }`);

    $('.gallery-form').removeClass('edit view');
    $('.gallery-form').addClass('view');

    $ref.find('input[name="gallery_email"]').val(userObj.email);
    $ref.find('input[name="gallery_password"]').val('GETOUTAHERE');
  }

  handleUpdateEmail(e) {
    var that = this;
    if (e) { e.preventDefault(); }
    
    var user = Cookie.getJSON('gallery-user');
    var $ref = $(`#${ this.state.generatedId }`);
    var emailForm = $ref.find('input[name="gallery_email"]');
    var emailVal = emailForm.val();

    let $errorsRef = $(`#${ this.state.generatedId } .errors`);
    let $successRef = $(`#${ this.state.generatedId } .success`);

    if (emailVal !== '') {
      this.state.api.updateUserAccount({
        token: user.token,
        email: emailVal,
      }, function(response) {
        if (response.success) {
          var updatedUser = Cookie.getJSON('gallery-user');
          that.updateUserDetails(updatedUser);
          emailForm.blur();
          $errorsRef.slideUp();
          setTimeout(() => {
            $errorsRef.find('p').text('');
          }, 201);

          $successRef.find('p').text('Your email was updated!');
          $successRef.slideDown();

          setTimeout(()=> {
            $successRef.slideUp();
            $successRef.find('p').text('');
          }, 1500);
        } else {
          $errorsRef.find('p').text(response.message);
          $errorsRef.slideDown();
          $successRef.slideUp();
        }
      });
    } else {
      //console.log('email, something is wrong');
    }
  }

  handleUpdatePassword(e) {
    if (e) { e.preventDefault(); }
    var that = this;

    var user = Cookie.getJSON('gallery-user');
    var $ref = $(`#${ this.state.generatedId }`);
    var pw = $ref.find('input[name="gallery_password"]');
    var pwVal = pw.val();

    let $errorsRef = $(`#${ this.state.generatedId } .errors`);
    let $successRef = $(`#${ this.state.generatedId } .success`);

    if (pwVal !== "") {
      this.state.api.updateUserAccount({
        token: user.token,
        pw: pwVal,
      }, (res) => { 
        if (res.success) {
          var updatedUser = Cookie.getJSON('gallery-user');
          that.updateUserDetails(user);
          pw.blur();
          $errorsRef.slideUp();
          setTimeout(() => {
            $errorsRef.find('p').text('');
          }, 201);

          $successRef.find('p').text('Your password was updated!');
          $successRef.slideDown();

          setTimeout(()=> {
            $successRef.slideUp();
            $successRef.find('p').text('');
          }, 1500);
        } else {
          $errorsRef.find('p').text(res.message);
          $errorsRef.slideDown();
          
          $successRef.slideUp();
          $successRef.find('p').text('');
        }
      });
    } else {
      //console.log('pw somethings wrong');
    }
  }

  /**
   * On input change, or change is clicked for either field
   * - Make editable (remove .view class from form container && add .edit class to form container)
   * - Reset password field (has temp password as placeholder)
   * - On submit (make ajax request && reset classes to original state)
   **/

  render() {
    return `
      <div class="manage-account">
        <h2>Manage My Account</h2>

        <div class="errors">
          <p></p>
        </div>
        <div class="success">
          <p></p>
        </div>
        <form class="gallery-form-update-email gallery-form view">
          <label for="gallery_email">
            <span>Email:</span>
          </label>
          <input type="email" name="gallery_email" required value="" />
          <div>
            <div class="change">
              <a>Change</a>
            </div>
            <div class="save">
              <button>Save</button>
              <a></a>
            </div>
          </div>
        </form>
        <form class="gallery-form-update-password gallery-form view">
          <label for="gallery_password">
            <span>Password:</span>
          </label>
          
          <input type="password" name="gallery_password" required />

          <div>
            <div class="change">
              <a>Change</a>
            </div>
            <div class="save">
              <button>Save</button>
              <a></a>
            </div>
          </div>
        </form>

        <div class="view-favorites">
          <div>
            <a href="${ this.state.baseUrl }/my-account/favorites">View Favorites</a>
          </div>

          <div>
            <a href="${ this.state.baseUrl }">View All Categories</a>
          </div>

          <div>
            <a href="${ this.state.baseUrl }/my-account/logout">Sign Out</a>
          </div>
        <div>

        <div class="hide redirects">
          <a href="${ this.state.baseUrl }" id="redirect-home">Home</a>
          <a href="${ this.state.baseUrl }/my-account/login" id="redirect-login"></a>
          <a href="${ this.state.baseUrl }/my-account/create" id="redirect-create"></a>
        </div>
      <div>
    `;
  }
}

export default GalleryManage;


// WEBPACK FOOTER //
// ./src/scripts/site/account-views/manage.js